module.exports = __webpack_public_path__ + "img/portrait-040.ee2cd88f.jpg";